import React from 'react';
import {Skeleton} from 'antd';
import styled from 'styled-components';
import {mediaScreenSizes} from '../../../utils/constans/styles/screenSizes';

const SkeletonCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  flex-wrap: nowrap;
  
  @media (max-width: ${mediaScreenSizes.mobile}) {
    flex-direction: column;
  }
`;

const SkeletonBrokerCard = styled.div`
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  padding: 13px 10px 14px 16px;
  width: 250px;
  min-width: 250px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  
  @media (max-width: ${mediaScreenSizes.mobile}) {
    width: 100%;
    min-width: unset;
  }
`;

const SkeletonBrokerInfo = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  flex: 1;
`;

const SkeletonOrderCard = styled.div`
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  padding: 16px 16px 17px 16px;
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
`;

const SkeletonOrderType = styled.div`
  width: 105px;
  flex-shrink: 0;
`;

const SkeletonOrderRoutes = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  align-items: flex-start;
  justify-content: center;
  row-gap: 7px;
  flex-grow: 1;
  flex-shrink: 0;
`;

const SkeletonOfferDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #D9D9D9;
  padding: 3px;
  min-width: 253px;
  gap: 8px;
`;

export const OrderRequestCardSkeleton: React.FC = () => {
  return (
    <SkeletonCardWrapper>
      <SkeletonBrokerCard>
        <SkeletonBrokerInfo>
          <Skeleton.Avatar active size={60} shape="circle" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
            <Skeleton.Input active size="small" style={{ width: '80%', height: 12 }} />
            <Skeleton.Input active size="small" style={{ width: '100%', height: 22 }} />
            <Skeleton.Input active size="small" style={{ width: '60%', height: 17 }} />
          </div>
        </SkeletonBrokerInfo>
        <Skeleton.Button active size="small" style={{ width: 45, height: 35 }} />
      </SkeletonBrokerCard>
      <SkeletonOrderCard>
        <SkeletonOrderType>
          <Skeleton.Button active size="small" style={{ width: 85, height: 30 }} />
        </SkeletonOrderType>
        <SkeletonOrderRoutes>
          <Skeleton.Input active size="small" style={{ width: '140px', height: 17 }} />
          <Skeleton.Input active size="small" style={{ width: '120px', height: 17 }} />
        </SkeletonOrderRoutes>
        <SkeletonOfferDetails>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center' }}>
            <Skeleton.Image style={{ width: 44, height: 44, borderRadius: 3 }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Skeleton.Input active size="small" style={{ width: '150px', height: 17 }} />
              <Skeleton.Input active size="small" style={{ width: '80px', height: 14 }} />
            </div>
          </div>
          <Skeleton.Button active size="small" style={{ width: 21, height: 21 }} />
        </SkeletonOfferDetails>
      </SkeletonOrderCard>
    </SkeletonCardWrapper>
  );
};

